(() => {
  'use strict';
  const nativeFetch = window.__serranoNativeFetch || window.fetch.bind(window);
  window.fetch = nativeFetch;
  if (!window.customElements) return;

  customElements.whenDefined('dn-home-box-builder').then(() => {
    const Constructor = customElements.get('dn-home-box-builder');
    const proto = Constructor?.prototype;
    if (!proto || typeof proto.addToCart !== 'function' || proto.addToCart.__serranoSourceScoped) return;

    const originalAddToCart = proto.addToCart;
    async function scopedAddToCart(...args) {
      const source = window.SerranoBuilderSource?.resolve?.() || 'Ana sayfa kutu kurucu';

      const scopedFetch = async (input, init = {}) => {
        const requestUrl = typeof input === 'string' ? input : input?.url || '';
        if (/\/cart\/add(?:\.js)?(?:\?|$)/.test(requestUrl) && typeof init.body === 'string') {
          try {
            const payload = JSON.parse(init.body);
            if (Array.isArray(payload?.items)) {
              let changed = false;
              payload.items.forEach((item) => {
                if (item?.properties && Object.prototype.hasOwnProperty.call(item.properties, '_Kaynak')) {
                  item.properties._Kaynak = source;
                  changed = true;
                }
              });
              if (changed) init = { ...init, body: JSON.stringify(payload) };
            }
          } catch (_) {}
        }
        return nativeFetch(input, init);
      };

      window.fetch = scopedFetch;
      try {
        return await originalAddToCart.apply(this, args);
      } finally {
        if (window.fetch === scopedFetch) window.fetch = nativeFetch;
      }
    }

    scopedAddToCart.__serranoSourceScoped = true;
    scopedAddToCart.__serranoOriginal = originalAddToCart;
    proto.addToCart = scopedAddToCart;
    window.__serranoBuilderSourceScope = '2026-08-15-v1';
  });
})();
